// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.custom-label-height[data-v-39458742]{\n    height: 27px;\n}\nh2[data-v-39458742]{\n    margin-top: 24px;\n}\nli[data-v-39458742]{\n    margin-top: 8px;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
